import { postFormData, get, del } from '../index'


export const createTemplate = postFormData('/twins/template')
export const getTwinProcessStatus = get('/twins/processing')
export const getTwinList = get('/twins/template/scroll')
export const getLatestTwin = get('/twins/latest')
export const createTwins = postFormData('/twins/clone')
export const getTemplateCount = get('/twins/template/count')